import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Campngplacemorachichincholi() {



    const cardData =
    {
        keyword: 'Camping Place Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Camping Place Morachi Chincholi Pune',
        headingDescription: 'Seeking a peaceful and adventurous camping place in Morachi Chincholi Pune? Anand Krushi Paryatan Kendra, nestled just 55 km from Pune on a sprawling 40‑acre agri‑tourism farm, offers an ideal blend of rustic camping and rural charm in a serene natural setting. Experience a memorable overnight stay under the stars with cozy rural-style tents, bonfire evenings, and open-air dining. By day, enjoy bullock cart and tractor rides, horse riding, boating, swimming, and a refreshing rain dance. Traditional village games, puppet and magic shows add cultural delight to the experience.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Tent Camping Under Stars",
    "description": "Experience open-sky camping with well-pitched tents set beside farms, trees, or water bodies. Sleep under the stars, surrounded by the soothing sounds of crickets, night birds, and rustling leaves—an escape from the city buzz."
  },
  {
    "title": "Evening Bonfire Sessions",
    "description": "Gather around a warm bonfire with friends or family, enjoy folk stories, light snacks like bhadang and roasted peanuts, or join in group singing and dholki music. A perfect rural-style campfire vibe for bonding and unwinding."
  },
  {
    "title": "Traditional Maharashtrian Dinner",
    "description": "Relish a homemade dinner served hot—bhakri, zunka, pithla, varan-bhat, pickles, and seasonal sweets. Cooked on wood-fired chulhas and served in an open farm setting, it adds warmth to your camp night."
  },
  {
    "title": "Stargazing & Night Photography",
    "description": "With minimal light pollution, Morachi Chincholi offers clear night skies for stargazing. Ideal for astronomy enthusiasts, photographers, or anyone who wants to simply lie back and gaze at constellations."
  },
  {
    "title": "Nature Trail & Sunrise Walks",
    "description": "Wake up early to explore nearby trails through fields, mango orchards, and around ponds. Morning walks often include peacock sightings and bird calls, giving a peaceful start to the day after your camp stay."
  },
  {
    "title": "Adventure & Rope Activities",
    "description": "Add excitement to your camping trip with low-rope adventures, balancing bridges, and mini climbing setups. Safe for both kids and adults, these activities promote teamwork and fun in a natural setting."
  },
  {
    "title": "Bullock Cart & Tractor Ride",
    "description": "Post-dinner or next morning, hop on a bullock cart or tractor ride around the village. It’s a slow, relaxing tour through the countryside, often paired with stories about the local farming lifestyle."
  },
  {
    "title": "Farm Animal Interaction Zone",
    "description": "Visit the dairy shed or petting area where you can feed calves, see ducks and hens, and even try your hand at milking a cow. A simple, joyful activity that city dwellers find both refreshing and memorable."
  },
  {
    "title": "Splash Pool & Rain Dance (Optional)",
    "description": "Some camping packages include access to water zones—colorful splash pools, rain dance areas with DJ music—great for cooling off in the afternoon before settling down for your evening campfire."
  },
  {
    "title": "Safe & Clean Camping Amenities",
    "description": "Tents are provided with bedding, clean washrooms nearby, solar lighting, and safety arrangements. Campsites are monitored by local staff to ensure a safe, comfortable stay for families, couples, or groups."
  }
],




"services": [
  {
    "name": "Nature Camping in Morachi Chincholi",
    "description": "Experience the calm and charm of nature with overnight camping at Anand Krushi Paryatan Kendra. Surrounded by lush farms, chirping birds, and peaceful trails, our nature camping offers the perfect environment for a rejuvenating break under the stars."
  },
  {
    "name": "Farm Camping Near Pune",
    "description": "Enjoy an authentic rural experience with our farm camping setup just a short drive from Pune. Guests can participate in farming activities during the day and relax around a campfire at night, all while staying in clean and comfortable tents."
  },
  {
    "name": "Tent Stay with Bonfire",
    "description": "Stay in cozy tents and end your day with a crackling bonfire. Share stories, play games, and enjoy hot farm-cooked meals as you unwind with your group around the fire under a clear, star-filled sky."
  },
  {
    "name": "Family-Friendly Camping Sites",
    "description": "Our campsite is safe and welcoming for families with children. With guided walks, clean toilets, farm-fresh food, and fun games for all ages, it’s the perfect weekend outing that connects you with nature."
  },
  {
    "name": "Group Camping Options",
    "description": "Whether you’re a college group, a team of colleagues, or a group of friends, we offer spacious group camping zones with activity add-ons like team games, cultural programs, or night trails."
  },
  {
    "name": "Safe Camping with Food and Activities",
    "description": "Anand Krushi ensures a secure environment with fenced premises, trained guides, and organized activities like bullock cart rides, bird watching, and storytelling sessions for a well-rounded camping experience."
  },
  {
    "name": "Bird Watching and Night Sky View",
    "description": "Start your mornings with peacock sightings and end your evenings gazing at the stars. Our rural skies are perfect for stargazing and unwinding, away from city light pollution."
  },
  {
    "name": "Kids Camping with Guides",
    "description": "We offer special camping experiences tailored for children, including nature exploration, traditional games, storytelling by the campfire, and safe supervision throughout the stay."
  },
  {
    "name": "Couple Camping Packages Near Pune",
    "description": "Looking for a quiet, romantic escape? Our couple camping packages include private tent arrangements, candlelight-style rural dinners, and nature walks — ideal for special occasions or peaceful bonding time."
  },
  {
    "name": "Riverside Camping Nearby",
    "description": "Located near a natural water body, guests can enjoy riverside relaxation during the day and tented stays nearby at night, giving a blend of water-based peace and farm fun."
  },
  {
    "name": "Weekend Camping Trip from Pune",
    "description": "Ideal for a short getaway, our weekend camping plans include full meals, fun group activities, nature interaction, and a digital detox — just 1.5 hours from Pune."
  },
  {
    "name": "Village-Style Camp Experience",
    "description": "Live like a local for a day with our village-style camp experience. Try cooking on chulhas, draw water from wells, and enjoy a community dinner under the open sky — all part of your stay."
  },
  {
    "name": "Adventure Camping for Students",
    "description": "Perfect for school or college outings, our student packages include adventure trails, obstacle courses, farming demos, and stargazing sessions — all designed to be educational and fun."
  },
  {
    "name": "Peaceful Campsite with Nature Trails",
    "description": "Explore curated nature trails around the farm during your camping stay. Whether it’s an early morning bird walk or a silent sunset stroll, you’ll find peace and inspiration on every path."
  },
  {
    "name": "Budget Camping in Morachi Chincholi",
    "description": "Affordable camping doesn't mean cutting corners. Our budget packages include tent stay, food, evening activities, and full access to the farm’s amenities — ideal for youth groups and budget travelers."
  }
],
"tableData": [
  ["Nature Camping in Morachi Chincholi", "- Farm Camping Near Pune"],
  ["Tent Stay with Bonfire", "- Family-Friendly Camping Sites"],
  ["Group Camping Options", "- Safe Camping with Food and Activities"],
  ["Bird Watching and Night Sky View", "- Kids Camping with Guides"],
  ["Couple Camping Packages Near Pune", "- Riverside Camping Nearby"],
  ["Weekend Camping Trip from Pune", "- Village-Style Camp Experience"],
  ["Adventure Camping for Students", "- Peaceful Campsite with Nature Trails"],
  ["Budget Camping in Morachi Chincholi", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Authentic Rural Camping Experience",
    "WhyChoosedescription": "Mauli Krushi Paryatan Kendra offers a genuine agro-tourism experience, allowing visitors to immerse themselves in rural life with activities like bullock cart rides, tractor tours, and bird watching amidst the presence of over 2,500 peacocks."
  },
  {
    "WhyChooseheading": "Diverse Outdoor Activities",
    "WhyChoosedescription": "Guests can enjoy a variety of outdoor activities including zip-lining, rain dance, swimming pool access, and traditional rural games such as Viti Dandu and Lagori, ensuring a fun-filled camping experience."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation Options",
    "WhyChoosedescription": "The center provides various stay options, including cottages and dormitories, equipped with modern amenities. Packages include meals, activities, and access to facilities like a children's park and hammock relaxation zones."
  },
  {
    "WhyChooseheading": "Cultural and Culinary Delights",
    "WhyChoosedescription": "Experience authentic Maharashtrian cuisine with dishes like Puran Poli, Maswadi, and Sorghum bread. Evening bonfires accompanied by music and dance add to the cultural richness of the camping experience."
  },
  {
    "WhyChooseheading": "Eco-Friendly and Peaceful Environment",
    "WhyChoosedescription": "Situated in a pollution-free zone, the campsite promotes well-being and a healthy lifestyle, offering a serene environment free from noise and pollution, perfect for relaxation and rejuvenation."
  },
  {
    "WhyChooseheading": "Convenient Location Near Pune",
    "WhyChoosedescription": "Located approximately 55 km from Pune, Mauli Krushi Paryatan Kendra is easily accessible, making it an ideal destination for a quick getaway to experience nature and rural life."
  }
]


























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Are there camping facilities available at Morachi Chincholi?',
    answer: 'Yes, several agro-tourism centers and resorts near Morachi Chincholi offer well-equipped camping facilities for a comfortable outdoor experience.',
  },
  {
    id: 'FAQ2',
    question: 'What types of camping options are available?',
    answer: 'You can choose from tents, eco-cottages, and dormitory-style accommodations depending on your preference and group size.',
  },
  {
    id: 'FAQ3',
    question: 'Is camping suitable for families and beginners?',
    answer: 'Absolutely! The campsites are family-friendly, safe, and ideal for both experienced campers and beginners looking for a nature getaway.',
  },
  {
    id: 'FAQ4',
    question: 'What activities are included during camping stays?',
    answer: 'Campers can enjoy bonfires, nature walks, stargazing, birdwatching, peacock spotting, and traditional village experiences.',
  },
  {
    id: 'FAQ5',
    question: 'Are meals provided during camping?',
    answer: 'Yes, most camping packages include meals prepared with fresh, organic farm produce, offering a wholesome farm-to-table dining experience.',
  },
  {
    id: 'FAQ6',
    question: 'Is camping available year-round at Morachi Chincholi?',
    answer: 'Camping is best enjoyed from October to March when the weather is cool and pleasant. Some camps may close during monsoon season.',
  },
  {
    id: 'FAQ7',
    question: 'What should I carry for a camping trip here?',
    answer: 'Bring comfortable clothing, warm layers for nights, insect repellent, sunscreen, flashlight, and personal toiletries.',
  },
  {
    id: 'FAQ8',
    question: 'Are campfires allowed at the campsite?',
    answer: 'Yes, supervised campfires or bonfires are usually part of the camping experience and provide a cozy evening atmosphere.',
  },
  {
    id: 'FAQ9',
    question: 'Can groups or corporate teams book camping stays?',
    answer: 'Yes, group bookings including corporate teams and college groups are welcomed with customized packages and activities.',
  },
  {
    id: 'FAQ10',
    question: 'How do I book a camping stay at Morachi Chincholi?',
    answer: 'You can contact agro-tourism resorts like Anand Krushi Paryatan Kendra directly to check availability and book your camping experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni, Pune',
    feedback: "Camping at Morachi Chincholi was an incredible experience. The peaceful environment and bonfire nights were unforgettable.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aditi Sharma, PCMC',
    feedback: "Loved the camping setup! Great food, cozy tents, and lots of nature activities. Perfect weekend getaway close to Pune.",
    rating: 5,
  },
];





























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Camping Place Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/camping-morachi-chincholi.jpg",
  "description": "Experience nature camping in Morachi Chincholi with family-friendly tent stays, bonfire, bird watching, night sky views, group camping, riverside spots, and peaceful nature trails near Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "520"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/camping"
  }
};




    return (
        <div>
<Helmet>
  <title>Camping Place Morachi Chincholi Pune | Tent Stay, Bonfire & Nature Trails</title>
  <meta 
    name="description" 
    content="Enjoy nature camping in Morachi Chincholi near Pune with family-friendly tent stays, bonfire, bird watching, night sky views, riverside camping, group options, and peaceful nature trails." 
  />
  <meta 
    name="keywords" 
    content="Nature camping in Morachi Chincholi, Farm camping near Pune, Tent stay with bonfire, Family-friendly camping sites, Group camping options, Safe camping with food and activities, Bird watching and night sky view, Kids camping with guides, Couple camping packages near Pune, Riverside camping nearby, Weekend camping trip from Pune, Village-style camp experience, Adventure camping for students, Peaceful campsite with nature trails, Budget camping in Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Campngplacemorachichincholi;